<template>
    <div class="ah-page salary-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>人事薪資</h1>
                        <el-select v-model="year" placeholder="年度" @change="updateData" class="title-dropdown">
                            <el-option v-for="item in yearList" :key="item.year" :label="item.year" :value="item.year" />
                        </el-select>
                    </div>
                    <div class="actions">
                        <el-button v-if="!isQR()" type="highlight" @click="$router.push({ name: 'salary-add' })">新增人事薪資支出</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color">
            <div class="ah-container">
                <div>
                    <v-chart
                        :option="chartOption"
                        theme="dark"
                        style="
                            width: 90%;
                            height: 180px;
                            margin-bottom: 50px;
                            margin-left: auto;
                            margin-right: auto;
                        "
                        ref="barchart"
                    />
                </div>
                <el-row :gutter="20">
                    <el-col :sm="4">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">累計人事薪資總額</div>
                                <div class="statis-num">
                                    <Money :v="totalAmount" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="4">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">累計人事費用</div>
                                <div class="statis-num">
                                    <Money :v="staffCost" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="4">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">累計薪資總計</div>
                                <div class="statis-num">
                                    <Money :v="salaryAmount" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="4">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">累計獎金績效</div>
                                <div class="statis-num">
                                    <Money :v="bonusAmount" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="4">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">累計代扣合計</div>
                                <div class="statis-num">
                                    <Money :v="withholdingAmount" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="4">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">累計實付金額</div>
                                <div class="statis-num">
                                    <Money :v="actuallyAmount" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="ah-container" style="margin-top: 25px">
            <div class="ah-panel">
                <div class="panel-body">
                    <center>
                        <el-radio-group v-model="tableTab" style="margin-bottom: 30px;">
                            <el-radio-button v-for="tabOption in tableTabOptionList" :key="tabOption.name" :label="tabOption.name">
                                {{ tabOption.label }}
                            </el-radio-button>
                        </el-radio-group>
                    </center>
                    <div style="min-height: 500px;">
                        <component
                            style="border-top: 1px solid #e6e6e6; margin-bottom: 10px;"
                            :data="datas[tableDataName.fieldName]"
                            :isLoading="isLoading"
                            :is="`${tableTab}Table`"
                            @row-click="onDataRowClick"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SummaryTable from '@/components/dashboard/Finance/Salary/Tables/SummaryTable.vue';
import FixedSalaryTable from '@/components/dashboard/Finance/Salary/Tables/FixedSalaryTable.vue';
import NonFixedSalaryTable from '@/components/dashboard/Finance/Salary/Tables/NonFixedSalaryTable.vue';
import BonusTable from '@/components/dashboard/Finance/Salary/Tables/BonusTable.vue';
import StaffTable from '@/components/dashboard/Finance/Salary/Tables/StaffTable.vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent]);

export default {
    components: {
        SummaryTable,
        FixedSalaryTable,
        NonFixedSalaryTable,
        BonusTable,
        StaffTable,
    },
    data() {
        return {
            // showEditDialog: false,
            totalDataCount: 0,
            year: null,
            isLoading: false,
            datas: [],
            yearList: [],

            tableTab: 'Summary',
            tableTabOptionList: [
                {
                    name: 'Summary',
                    fieldName: 'statisticsItems',
                    label: '總表',
                },
                {
                    name: 'FixedSalary',
                    fieldName: 'fixedSalaryItems',
                    label: '固定薪資',
                },
                {
                    name: 'NonFixedSalary',
                    fieldName: 'nonFixedSalaryItems',
                    label: '非固定薪資',
                },
                {
                    name: 'Bonus',
                    fieldName: 'bonusItems',
                    label: '績效、獎金',
                },
                {
                    name: 'Staff',
                    fieldName: 'staffCostItems',
                    label: '人事費用',
                },
            ],

            totalAmount: 0,
            actuallyAmount: 0,
            bonusAmount: 0,
            salaryAmount: 0,
            staffCost: 0,
            withholdingAmount: 0,
        };
    },
    created() {
        this.$api({
            url: 'SalaryManagementPage/GetQueryYearOptions',
            method: 'GET',
        })
            // 取得成功
            .then((resp) => {
                // 更新資料
                this.yearList = resp.data.options;

                // 網址有年份
                if (this.$route.query && this.$route.query.year) {
                    this.year = this.$route.query.year;
                } else {
                    this.year = this.yearList[0].year;
                }

                this.updateData();
            });
    },
    computed: {
        tableDataName() {
            return this.tableTabOptionList.find((o) => o.name === this.tableTab);
        },
        chartOption() {
            if (!this.datas.statisticsItems) {
                return null;
            }

            const series = [];
            const fixedSalaryAmounts = [];
            const nonFixedSalaryAmounts = [];
            const bonusAmounts = [];
            const staffCostAmounts = [];
            const totals = [];
            for (let i = 0; i < 12; i += 1) {
                fixedSalaryAmounts[i] = null;
                nonFixedSalaryAmounts[i] = null;
                bonusAmounts[i] = null;
                staffCostAmounts[i] = null;
                totals[i] = null;
            }
            this.datas.statisticsItems.forEach((item) => {
                const m = item.month - 1;
                fixedSalaryAmounts[m] = item.fixedSalaryAmount;
                nonFixedSalaryAmounts[m] = item.nonFixedSalaryAmount;
                bonusAmounts[m] = item.bonusAmount;
                staffCostAmounts[m] = item.staffCostAmount;
                totals[m] = item.staffSalaryAmount;
            });

            const averageSalaryAmounts = [];
            const salaryPeopleAmounts = [];
            this.datas.fixedSalaryItems.forEach((item) => {
                const m = item.month - 1;
                averageSalaryAmounts[m] = Math.round(item.averageSalary);
                salaryPeopleAmounts[m] = item.headcount;
            });

            series.push({
                name: '人事薪資總額',
                type: 'line',
                animation: false,
                areaStyle: {},
                data: totals,
            });

            series.push({
                name: '固定薪資',
                type: 'line',
                animation: false,
                data: fixedSalaryAmounts,
            });

            series.push({
                name: '領薪人數',
                type: 'line',
                animation: false,
                data: salaryPeopleAmounts,
            });

            series.push({
                name: '平均薪資',
                type: 'line',
                animation: false,
                data: averageSalaryAmounts,
            });

            series.push({
                name: '非固定薪資',
                type: 'line',
                animation: false,
                data: nonFixedSalaryAmounts,
            });

            series.push({
                name: '獎金、績效',
                type: 'line',
                animation: false,
                data: bonusAmounts,
            });

            series.push({
                name: '人事費用',
                type: 'line',
                animation: false,
                data: staffCostAmounts,
            });

            const returnChartOption = {
                tooltip: {
                    trigger: 'axis',
                },
                backgroundColor: 'transparent',
                grid: {
                    top: 30,
                    left: 0,
                    bottom: 0,
                    right: 15,
                    containLabel: true,
                },
                legend: {
                    data: ['固定薪資', '領薪人數', '平均薪資', '非固定薪資', '獎金、績效', '人事費用', '人事薪資總額'],
                },
                dataset: { source: [] },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(255,255,255,0.2)',
                            width: 1,
                            type: 'solid',
                        },
                    },
                },
                series,
            };

            return returnChartOption;
        },
    },
    methods: {
        // 按下表格一行
        onDataRowClick(data) {
            console.log(data);
            this.$router.push({
                name: 'salary-edit',
                params: {
                    year: data.year,
                    month: data.month,
                },
            });
        },
        async updateData() {
            this.isLoading = true;

            try {
                const resp = await this.$api({
                    url: 'SalaryManagementPage/GetList',
                    method: 'GET',
                    params: { PageNum: 1, PageSize: 12, Year: this.year },
                });
                const { statisticsInfo, amount } = resp.data;
                console.log('Salary', resp);

                this.datas = resp.data;
                // 累計人事薪資總額
                this.totalAmount = amount;
                // 累計資料
                this.staffCost = statisticsInfo.staffCost; // 累計人事費用
                this.salaryAmount = statisticsInfo.salaryAmount; // 累計薪資總計
                this.bonusAmount = statisticsInfo.bonusAmount; // 累計獎金績效
                this.withholdingAmount = statisticsInfo.withholdingAmount; // 累計代扣合計
                this.actuallyAmount = statisticsInfo.actuallyAmount; // 累計實付金額
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
<style lang="scss">
.salary-page {
    .primary-number {
        font-size: 11pt;
    }
    .sub-numbers {
        margin-top: 5px;
        font-size: 9pt;
        color: #bbb;
    }
    .el-table__header th {
        background-color: #f5f7fa;
        font-weight: bold;
        color: #444;
    }

    td {
        vertical-align: top;
    }
}
</style>
